// extracted by mini-css-extract-plugin
export default {"description":"SingleArtPage_description__7jyxs","descriptionContainer":"SingleArtPage_descriptionContainer__O7iZb"};